import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import React, { useState, useContext, useMemo } from "react";
import MatrixStats from "./KeyMatrixCharts/MatrixStats";
import WalletAnalysisChart from "./KeyMatrixCharts/WalletAnalysisChart";
import UserMatrixChart from "./KeyMatrixCharts/UserMatrixChart";
import ObjectivesBreakdownChart from "./KeyMatrixCharts/ObjectivesBreakdown";
import CohortChart from "./KeyMatrixCharts/CohortChart";
import KeyMatrixProvider, {
  KeyMatrixContext,
} from "./context/KeyMatrixProvider";
import KeyMatrixHeader from "./KeyMatrixCharts/KeyMatrixHeader";
import useAnalyticsModule from "hooks/useAnalyticsModule";
import { Box } from "@mui/material";
import EmptyImgStatus from "components/EmptyState/EmptyImageStatus";
import useNavigateEntity from "hooks/useNavigateEntity";
import LoadingFilter from "components/LoadingComponent/LoadingFilter";
import _ from "lodash";
import { useOutletContext, useParams } from "react-router";
import { useIntl } from "react-intl";

export default function KeyMatrix() {
  return (
    <KeyMatrixProvider>
      <KeyMatrixContent />
    </KeyMatrixProvider>
  );
}

function KeyMatrixContent() {
  const { formatMessage } = useIntl();
  const { navigateEntity } = useNavigateEntity();
  const { isLoading } = useContext(KeyMatrixContext);
  const hasAnyIsLoading = _.some(_.values(isLoading));
  const { subEntityName } = useParams();
  const [entityName] = useOutletContext();
  const { attributionConnect } = useAnalyticsModule();
  const isConnected = subEntityName || attributionConnect;
  const dynamicApiUrl = useMemo(() => {
    switch (true) {
      case !!subEntityName:
        return `apiEvaluate`;
      default:
        return `api`;
    }
  }, [subEntityName]);

  const dynamicEntityName = useMemo(() => {
    switch (true) {
      case !!subEntityName:
        return `${entityName}/${subEntityName}`;
      default:
        return entityName;
    }
  }, [entityName, subEntityName]);

  if (!isConnected)
    return (
      <Box mt="12px">
        <EmptyImgStatus
          type="tracking"
          backgroundImg="Key_Matrix"
          title={formatMessage({
            id: "emptyState.trackingTagNotInstalled.title",
          })}
          description={formatMessage({
            id: "emptyState.trackingTagNotInstalled.description",
          })}
          onClick={() =>
            navigateEntity(
              "/settings/general/integration/attribution?from=analytics/website"
            )
          }
        />
      </Box>
    );

  return (
    <Grid
      container
      spacing={1}
      sx={{ mt: "12px", position: "relative" }}
      alignItems="stretch"
      className="fade-up-more"
    >
      {hasAnyIsLoading && <LoadingFilter />}
      <Grid item xs={12}>
        <KeyMatrixHeader />
      </Grid>
      <MatrixStats
        dynamicApiUrl={dynamicApiUrl}
        dynamicEntityName={dynamicEntityName}
      />
      <Grid item xs={12} md={6}>
        <WalletAnalysisChart
          dynamicApiUrl={dynamicApiUrl}
          dynamicEntityName={dynamicEntityName}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <UserMatrixChart
          dynamicApiUrl={dynamicApiUrl}
          dynamicEntityName={dynamicEntityName}
        />
      </Grid>
      <Grid item xs={12}>
        <CohortChart
          dynamicApiUrl={dynamicApiUrl}
          dynamicEntityName={dynamicEntityName}
        />
      </Grid>
      <Grid item xs={12}>
        <ObjectivesBreakdownChart
          dynamicApiUrl={dynamicApiUrl}
          dynamicEntityName={dynamicEntityName}
        />
      </Grid>
    </Grid>
  );
}
